import { ImageType } from "@smile2impress/components/relaunch";

export function getImageUrl(
    imageUrl: string | undefined,
    baseUrl: string | undefined
): string {
    if (!imageUrl) return "";

    const trimmed = imageUrl.trim();
    if (
        trimmed.startsWith("http://") ||
        trimmed.startsWith("https://") ||
        trimmed.startsWith("//")
    ) {
        return trimmed;
    }

    if (!baseUrl) {
        return trimmed;
    }

    const origin = baseUrl.replace(/\/$/, "");
    const path = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
    return `${origin}${path}`;
}

export function getMobileImageUrl(
    image: { mobile?: { url?: string } } | undefined,
    baseUrl: string | undefined
): string {
    return getImageUrl(image?.mobile?.url, baseUrl);
}

export function getDesktopImageUrl(
    image: { desktop?: { url?: string } } | undefined,
    baseUrl: string | undefined
): string {
    return getImageUrl(image?.desktop?.url, baseUrl);
}

const IMAGE_TYPE_JPG_LONG = "jpeg";
const IMAGE_TYPE_JPG_SHORT = "jpg";
// You can't extract string s from type
// So this array must be updated if original type was changed
// And add "jpg" as a fallback for "jpeg"
export const IMAGE_TYPES: ImageType[] = [IMAGE_TYPE_JPG_LONG, "png", "webp"];

export function getImageExtenstion(filename: string): ImageType | null {
    const splitted = filename.split(".");
    if (splitted?.length < 2) return null;
    let extension = splitted.pop()?.toLowerCase();

    // We don't have "jpg" in the original type, but the mime type of "jpeg" and "jpg" is the same
    // Mark ".jpg" file as "jpeg" for return value
    if (extension === IMAGE_TYPE_JPG_SHORT) extension = IMAGE_TYPE_JPG_LONG;

    return IMAGE_TYPES.includes(extension as ImageType)
        ? (extension as ImageType)
        : null;
}
